import Vue from 'vue'
import Vuetify from 'vuetify'
import IconComponent from '../components/IconComponent.vue'
import 'vuetify/dist/vuetify.min.css'
import es from 'vuetify/lib/locale/es'

Vue.use(Vuetify)

// Radio.co-inspired tokens, manteniendo el rojo Inovanex
const inovanexRed = '#f8192c'
const inovanexRedDark = '#d91426'
const midnight = '#0f1f3d'
const slate = '#20355a'

export default new Vuetify({
    lang: {
        locales: { es },
        current: 'es'
    },
    icons: {
        component: IconComponent,
        values: {
            dropdown:   { component: IconComponent, props: { icon: 'expand-more' } },
            poweroff:   { component: IconComponent, props: { icon: 'mdi-power-standby' } },
            unfold:     { component: IconComponent, props: { icon: 'mdi-unfold-more-horizontal' } },
            menu:       { component: IconComponent, props: { icon: 'mdi-menu' } },
            prev:       { component: IconComponent, props: { icon: 'mdi-chevron-left' } },
            next:       { component: IconComponent, props: { icon: 'mdi-chevron-right' } },
            sort:       { component: IconComponent, props: { icon: 'mdi-sort' } },
            clear:      { component: IconComponent, props: { icon: 'mdi-close' } },
            close:      { component: IconComponent, props: { icon: 'mdi-close' } },
            checkboxOn: { component: IconComponent, props: { icon: 'mdi-checkbox-marked' } },
            checkboxOff:{ component: IconComponent, props: { icon: 'mdi-checkbox-blank-outline' } }
        }
    },

    theme: {
        options: { customProperties: true },
        themes: {
            light: {
                primary:   inovanexRed,
                secondary: midnight,
                accent:    slate,
                info:      '#228be6',
                success:   '#1ebd53',
                warning:   '#fcc419',
                error:     inovanexRedDark,
                background:'#f8f9fa',
                surface:   '#ffffff'
            },
            dark: {
                primary:   inovanexRed,
                secondary: midnight,
                accent:    slate,
                info:      '#4dabf7',
                success:   '#38d9a9',
                warning:   '#fcc419',
                error:     inovanexRedDark,
                background:'#0f0f11',
                surface:   '#18191c'
            }
        }
    }
})
